import { createPortal } from "react-dom";
import Card from "./Card";
import ModalHeader from "./ModalHeader";

function Modal(props: ModalProps) {
  if (!props.shown) return null;

  // Portal pra document.body de propósito — um modal chamado de dentro de
  // qualquer ancestral com `filter` (ex: Card usa drop-shadow) vira preso
  // DENTRO da caixa desse ancestral em vez de fixo na tela de verdade,
  // porque filter cria um containing block novo pra descendente
  // position:fixed (spec do CSS). Se esse mesmo ancestral também tem
  // overflow-hidden (ex: o Card que embrulha GroupDetailPanel em
  // Whatsapp.page.tsx), o modal fica cortado sem aviso nenhum — foi
  // exatamente isso que quebrou o modal de grupo mesmo depois do fix de
  // max-h/overflow no Card interno. Portal garante que isso nunca aconteça
  // de novo, não importa de onde o Modal for chamado.
  return createPortal(
    <div className="fixed flex justify-center items-center top-0 left-0 w-full h-screen z-50">
      <div
        className="absolute w-full h-full"
        style={{
          backgroundColor: "rgba(80,78,100,0.5)",
          backdropFilter: "blur(2px)",
        }}
        onClick={props.onClose}
      ></div>
      <Card className={`z-20 max-h-[90vh] overflow-y-auto ${props.className}`}>
        <ModalHeader
          tooltipMessageId={props.tooltipMessageId}
          onClose={props.onClose}
        >
          {props.title}
        </ModalHeader>
        {props.children}
      </Card>
    </div>,
    document.body,
  );
}

export default Modal;
export type ModalProps = {
  shown: boolean;
  title: string;
  children: React.ReactNode;
  tooltipMessageId?: string;
  onClose?: () => void;
  className?: string;
};
